// eslint-disable-next-line import/extensions -- package requires explicit .js extension
import '@formatjs/intl-segmenter/polyfill.js'

window.global ||= window

setTimeout(async () => {
  const { scan } = await import('react-scan')
  scan({
    enabled: import.meta.env.VITE_ENV === 'local',
    trackUnnecessaryRenders: true,
  })
}, 1000)
